import cliente from './cliente'

export default baseUrl => {
    return {
        cliente: cliente(baseUrl),
    }
}
